import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ROUTER_BASE } from './config';
import { AppShell } from './layout/AppShell';
import { OverviewView } from './views/Overview/OverviewView';
import { BoardView } from './views/Board/BoardView';
import { CalendarView } from './views/Calendar/CalendarView';
import { ScrapersView } from './views/Scrapers/ScrapersView';
import { RafflesView } from './views/Raffles/RafflesView';
import { SocialView } from './views/Social/SocialView';
import { AddScraperView } from './views/AddScraper/AddScraperView';
import { SettingsView } from './views/Settings/SettingsView';
import { NotFound } from './views/NotFound';
import { LoginView } from './views/Login/LoginView';

const router = createBrowserRouter(
  [
    { path: '/login', element: <LoginView /> },
    {
      path: '/',
      element: <AppShell />,
      children: [
        // Raffle modals are URL state on every view that opens them.
        { index: true, element: <BoardView /> },
        { path: 'raffle/:id', element: <BoardView /> },
        { path: 'calendar', element: <CalendarView /> },
        { path: 'calendar/:id', element: <CalendarView /> },
        { path: 'ops', element: <OverviewView /> },
        // Modal state lives in the URL, so a scraper's logs are linkable.
        { path: 'scrapers', element: <ScrapersView /> },
        { path: 'scrapers/:name', element: <ScrapersView /> },
        { path: 'scrapers/:name/:tab', element: <ScrapersView /> },
        { path: 'raffles', element: <RafflesView /> },
        { path: 'raffles/:id', element: <RafflesView /> },
        { path: 'social', element: <SocialView /> },
        { path: 'add-scraper', element: <AddScraperView /> },
        { path: 'settings', element: <SettingsView /> },
        { path: 'settings/:tab', element: <SettingsView /> },
        { path: '*', element: <NotFound /> },
      ],
    },
  ],
  {
    basename: ROUTER_BASE,
    // Opt in early so the v6 console warnings stay quiet and the eventual v7
    // upgrade is not a behaviour change. Note v7_startTransition is a
    // RouterProvider prop, not a router option — they are separate configs.
    future: { v7_relativeSplatPath: true },
  },
);

export function App() {
  return <RouterProvider router={router} future={{ v7_startTransition: true }} />;
}
